// Channel menu permissions, copied from the Windows app (frmHome.cs loadAccess()).
// Returns all three channel flags so the Availability Manual Override and Rate Control
// pages can reuse this helper when they are added.

// Channel pages that exist in this web app. Add 'availabilityManualOverride' and
// 'rateControl' here when those pages are built, so the Channel menu shows for them too.
const IMPLEMENTED = ['stopSale', 'availabilityManualOverride', 'rateControl'];

function readJson(key) {
    try
    {
        return JSON.parse(localStorage.getItem(key));
    }
    catch (err)
    {
        return null;
    }
}

export function isChannelAdmin(role) {
    return role === 'administrator' || role === 'manager' || role === 'supervisor';
}

export function getChannelAccess(role) {
    let access = {
        availabilityManualOverride: false,
        stopSale: false,
        rateControl: false,
        showMenu: false
    };

    if(role === undefined || role === null || role === '')
    {
        role = localStorage.getItem('role');
    }

    let channelobj = readJson('channelsetting');

    if(channelobj === undefined || channelobj === null || channelobj.data === undefined || channelobj.data === null)
    {
        return access;
    }

    if(channelobj.data.channelName === undefined || channelobj.data.channelName === null || channelobj.data.channelName.trim() === '')
    {
        return access;
    }

    let customobj = readJson('customsetting');
    let noCustom = customobj === undefined || customobj === null || customobj.data === undefined || customobj.data === null;

    // Windows leaves the Channel ribbon at its default (all shown) when there is no custom setting.
    // Here only administrator/manager/supervisor get that; other roles need the custom flags.
    if(noCustom && !isChannelAdmin(role))
    {
        return access;
    }

    if(isChannelAdmin(role))
    {
        access.availabilityManualOverride = true;
        access.stopSale = true;
        access.rateControl = true;
    }
    else
    {
        access.availabilityManualOverride = customobj.data.availabilityManualOverride === true;
        access.stopSale = customobj.data.stopSale === true;
        access.rateControl = customobj.data.rateControl === true;
    }

    access.showMenu = IMPLEMENTED.some(x => access[x] === true);

    return access;
}

// Read-only: Channel sync is paused when stopSync.disableSync is true and toDate is today or later.
export function getSyncPause() {
    let channelobj = readJson('channelsetting');

    if(channelobj === undefined || channelobj === null || channelobj.data === undefined || channelobj.data === null)
    {
        return null;
    }

    let stopSync = channelobj.data.stopSync;

    if(stopSync === undefined || stopSync === null || stopSync.disableSync !== true)
    {
        return null;
    }

    if(stopSync.toDate === undefined || stopSync.toDate === null || stopSync.toDate === '')
    {
        return null;
    }

    let toDate = new Date(stopSync.toDate);
    if(isNaN(toDate.getTime()))
    {
        return null;
    }

    let today = new Date();
    today.setHours(0, 0, 0, 0);
    toDate.setHours(0, 0, 0, 0);

    if(toDate < today)
    {
        return null;
    }

    return stopSync.toDate;
}
